import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NotInput, NotModal } from '@nebalkon-workspace/ui-kit';
import { CabinetButtonComponent } from '../ui/cabinet-button.component';

export interface CabinetPromptDialogData {
  title: string;
  message: string;
  okLabel?: string;
  cancelLabel?: string;
  inputPlaceholder?: string;
  inputValue?: string;
}

@Component({
  selector: 'lib-cabinet-prompt-dialog',
  imports: [NotModal, NotInput, CabinetButtonComponent, ReactiveFormsModule],
  templateUrl: './cabinet-prompt-dialog.component.html',
  styleUrl: './cabinet-prompt-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinetPromptDialogComponent {
  readonly data = inject(DIALOG_DATA) as CabinetPromptDialogData;
  readonly #dialogRef = inject(DialogRef<string | undefined>);

  protected readonly inputControl = new FormControl<string>(
    this.data.inputValue ?? '',
    {
      nonNullable: true,
    },
  );

  protected cancel(): void {
    this.#dialogRef.close(undefined);
  }

  protected confirm(): void {
    this.#dialogRef.close(this.inputControl.value);
  }
}
